module.exports = __webpack_public_path__ + "80168d312b80b7fd26c37f01ffe96a1a.png";